module.exports = __webpack_public_path__ + "static/img/powiekszGrafike.9fce66ec.png";